var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLines(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 646,
    height: 367,
    viewBox: "0 0 646 367",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-97.7493 287.8C-22.581 315.265 164.314 334.151 310.547 189.979C383.44 122.069 548.807 3.38572 627.131 71.9296",
    stroke: "white",
    strokeWidth: 0.955435
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M-102.897 278.634C-27.5694 306.565 159.573 326.178 305.524 181.178C378.288 112.891 543.469 -6.33917 622.078 63.0414",
    stroke: "white",
    strokeWidth: 0.955435
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M-103.327 268.503C-28.1591 295.968 158.736 314.855 304.969 170.683C377.862 102.773 543.229 -15.9107 621.553 52.6332",
    stroke: "white",
    strokeWidth: 0.955435
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M-105.764 258.41C-30.4366 286.341 156.706 305.954 302.656 160.954C375.421 92.6666 540.602 -26.5633 619.211 42.8173",
    stroke: "white",
    strokeWidth: 0.955435
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M-111.618 250.132C-36.4501 277.597 150.445 296.484 296.678 152.312C369.571 84.4018 534.938 -34.2818 613.262 34.2622",
    stroke: "white",
    strokeWidth: 0.955435
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M-113.802 240.782C-38.6337 268.247 148.261 287.134 294.494 142.961C367.387 75.0517 532.755 -43.6319 611.078 24.9121",
    stroke: "white",
    strokeWidth: 0.955435
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M-117.794 232.047C-42.6259 259.512 144.269 278.399 290.502 134.227C363.395 66.3168 528.763 -52.3667 607.086 16.1772",
    stroke: "white",
    strokeWidth: 0.955435
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M-120.88 223.007C-45.7118 250.472 141.183 269.359 287.416 125.187C360.309 57.2768 525.677 -61.4068 604 7.13715",
    stroke: "white",
    strokeWidth: 0.955435
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M-123.968 213.965C-48.7997 241.43 138.095 260.316 284.328 116.144C357.221 48.2343 522.589 -70.4492 600.912 -1.90533",
    stroke: "white",
    strokeWidth: 0.955435
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M-132.228 205.444C-57.0595 232.909 129.835 251.795 276.068 107.623C348.961 39.7133 514.329 -78.9702 592.653 -10.4263",
    stroke: "white",
    strokeWidth: 0.955435
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M-137.376 196.276C-62.048 224.207 125.095 243.82 271.045 98.8203C343.809 30.5328 508.99 -88.6971 587.6 -19.3165",
    stroke: "white",
    strokeWidth: 0.955435
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M-137.806 186.147C-62.6376 213.612 124.257 232.499 270.49 88.3266C343.383 20.4169 508.751 -98.2666 587.074 -29.7227",
    stroke: "white",
    strokeWidth: 0.955435
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M-140.243 176.054C-64.9151 203.985 122.228 223.598 268.178 78.5981C340.942 10.3106 506.123 -108.919 584.732 -39.5387",
    stroke: "white",
    strokeWidth: 0.955435
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M-146.097 167.777C-70.9286 195.242 115.966 214.129 262.199 69.9565C335.092 2.04678 500.46 -116.637 578.783 -48.0928",
    stroke: "white",
    strokeWidth: 0.955435
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M-148.281 158.424C-73.1122 185.889 113.783 204.776 260.015 60.6035C332.909 -7.30625 498.276 -125.99 576.6 -57.4459",
    stroke: "white",
    strokeWidth: 0.955435
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M-152.271 149.692C-77.1025 177.157 109.792 196.043 256.025 51.8711C328.918 -16.0387 494.286 -134.722 572.61 -66.1783",
    stroke: "white",
    strokeWidth: 0.955435
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M-155.359 140.649C-80.1904 168.114 106.704 187.001 252.937 42.8286C325.831 -25.0812 491.198 -143.765 569.522 -75.2208",
    stroke: "white",
    strokeWidth: 0.955435
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M-158.445 131.609C-83.2763 159.074 103.619 177.961 249.851 33.7886C322.745 -34.1212 488.112 -152.805 566.436 -84.2608",
    stroke: "white",
    strokeWidth: 0.955435
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLines);
export default __webpack_public_path__ + "static/media/lines.fa6b2c312ee31facb20fd5c4cc74ad98.svg";
export { ForwardRef as ReactComponent };